import type { CSSProperties } from 'react';

import BaySpinner from '../BaySpinner';

interface BayWidgetLoadingPlaceholderProps {
	height?: string | number;
	title?: string;
	className?: string;
	customStyle?: CSSProperties;
	loadingClass?: string;
	variant?: string;
	textColor?: string;
}

const BayWidgetLoadingPlaceholder = ({
	height = '100%',
	title = '',
	className = '',
	customStyle = {},
	loadingClass = '',
	variant = '',
	textColor = '',
}: BayWidgetLoadingPlaceholderProps) => {
	// Unitless strings ("60") are invalid CSS and get dropped, collapsing the box.
	// Callers have passed those since the TS cutover turned height={60} into height="60".
	const resolvedHeight = /^\d+$/.test(String(height)) ? `${height}px` : height;

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${className}`}
			style={{ height: resolvedHeight, zIndex: 10, ...customStyle }}
		>
			<BaySpinner
				className={loadingClass}
				textColor={textColor}
				title={title}
				variant={variant}
			/>
		</div>
	);
};

export default BayWidgetLoadingPlaceholder;
